module.exports = "img/cedel-logo.71d0c1.jpg";